/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { NotificationConfigurationModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class NotificationConfigurationClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags NotificationConfiguration
   * @name NotificationConfigurationGet
   * @summary Returns FI notification configuration.
   * @request GET:/notificationConfiguration
   */
  notificationConfigurationGet = (params: RequestParams = {}) =>
    this.http.request<NotificationConfigurationModelDto, any>({
      path: `/notificationConfiguration`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NotificationConfiguration
   * @name NotificationConfigurationPut
   * @summary Updates FI notification configurations.
   * @request PUT:/notificationConfiguration
   */
  notificationConfigurationPut = (
    data: NotificationConfigurationModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<NotificationConfigurationModelDto, any>({
      path: `/notificationConfiguration`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
